import DataList from "components/datatable/DataList";
import React from "react";
import useAxiosFunction from "hooks/useAxiosFunction";
import { useAuth } from "context/AuthProvider";
import { RuleOptionalEmail, RuleRequired } from "utils/MyUtils";
import { boolText, hasPermission, showEmpty } from "./SystemPageUtils";

export default function UserManagementPage() {
  const { user } = useAuth();
  const [, , , axiosFetch] = useAxiosFunction();
  const canManage = hasPermission(user, "system.user.manage");

  const coltype = {
    id_user: { type: "hidden", name: "id_user" },
    username: { label: "Username", type: "text", name: "username", colsize: 4, validation: RuleRequired, width: 180 },
    password: { label: "Password", type: "password", name: "password", colsize: 4 },
    email: { label: "Email", type: "text", name: "email", colsize: 4, validation: { validate: RuleOptionalEmail }, renderFunc: (val) => showEmpty(val) },
    id_profil: { label: "ID Profil Personal", type: "text", name: "id_profil", colsize: 6, renderFunc: (val) => showEmpty(val) },
    profile_name: { label: "Profil", renderFunc: (val) => showEmpty(val), width: 220 },
    total_contexts: { label: "Context", align: "center", renderFunc: (val) => showEmpty(val, "0"), width: 90 },
    last_login_at: { label: "Last Login", renderFunc: (val) => showEmpty(val), width: 180 },
    must_change_password: { label: "Must Change Password", type: "checkbox", name: "must_change_password", renderFunc: (val) => (val ? "YA" : "TIDAK"), colsize: 3, width: 160 },
    is_active: { label: "Status", type: "checkbox", name: "is_active", renderFunc: (val) => boolText(val), colsize: 3, width: 120 },
    action: { label: "Aksi", align: "center", width: 100 },
  };

  const saveUser = async (form, defaultValue = {}) => {
    const id = form?.id_user || defaultValue?.id_user || "";
    const method = id ? "PUT" : "POST";
    const url = id ? `/system/users/${id}` : "/system/users";

    return axiosFetch({
      method,
      url,
      auth: true,
      data: {
        username: form.username,
        password: form.password || "",
        email: form.email || "",
        id_profil: form.id_profil || "",
        must_change_password: Boolean(form.must_change_password),
        is_active: Boolean(form.is_active),
      },
    });
  };

  return (
    <DataList
      title="Daftar User"
      coltype={coltype}
      dlist={{
        url: "/system/users",
        columns: ["no", "username", "email", "profile_name", "total_contexts", "last_login_at", "is_active", "action"],
        filter: [{ dtype: "q", name: "q", colsize: 4 }],
        sort_by: ["username", "email", "profile_name"],
      }}
      addconfig={canManage ? {
        columns: ["username", "password", "email", "id_profil", "must_change_password", "is_active"],
        title: "Penambahan User",
        label_tool: "Tambah User",
        saveHandle: saveUser,
      } : null}
      editconfig={canManage ? {
        columns: ["id_user", "username", "password", "email", "id_profil", "must_change_password", "is_active"],
        title: "Perubahan User",
        url: "/system/users",
        urlitem: "/system/users",
        cellid: "id_user",
        saveHandle: saveUser,
        coltype: {
          ...coltype,
          username: { ...coltype.username, disabled: true },
          password: { ...coltype.password, label: "Password Baru" },
        },
      } : null}
      delconfig={canManage ? {
        url: "/system/users",
        cellid: "id_user",
        cellname: "username",
      } : null}
    />
  );
}
